import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';

import { colorsV2 } from '../colors-v2';
import { shadows } from '../shadows';
import { ResponsiveTypography } from '../Typography/v3/ResponsiveTypography';

const Container = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 14px;

  cursor: pointer;

  .icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 20px;
    color: ${colorsV2.white100};

    padding: 12px 10px;
    border-radius: 8px;
  }

  &.style-1 {
    padding: 12px;
    background-color: ${colorsV2.white100};
    border: 1px solid ${colorsV2.neutral20};
    border-radius: 12px;

    &:hover {
      border: 1px solid ${colorsV2.neutral120};
      box-shadow: ${shadows.neutralShadowToBot5};
    }
  }

  &.style-2 {
    background-color: ${colorsV2.white100};

    .icon-wrapper {
      transition: all 0.25s ease-in-out;
    }

    &:hover {
      .icon-wrapper {
        font-size: 26px;
        padding: 12px;
      }
    }
  }

  &.primary {
    .icon-wrapper {
      background-color: ${colorsV2.primary100};
    }
  }

  &.green {
    .icon-wrapper {
      background-color: ${colorsV2.green100};
    }
  }

  &.blue {
    .icon-wrapper {
      background-color: ${colorsV2.blue100};
    }
  }
`;

interface PromoCardProps {
  type?: 'style-1' | 'style-2';
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  color?: string;
}

export const PromoCard = (props: PromoCardProps) => {
  const { type = 'style-1', title, description, icon, color } = props;

  return (
    <Container className={cl('promo-card', type, color)}>
      <div className="icon-wrapper">{icon}</div>
      <div>
        <ResponsiveTypography.Paragraph variant="semi-bold/14-20" color="neutral180" mb="4px">
          {title}
        </ResponsiveTypography.Paragraph>
        <ResponsiveTypography.Paragraph variant="regular/14-20" color="neutral160">
          {description}
        </ResponsiveTypography.Paragraph>
      </div>
    </Container>
  );
};
